import React, { useRef, useState, useEffect } from 'react'
import SriLankaImageSlider from './SriLankaImageSlider'
import { Link } from 'react-router-dom'
import { motion, useInView } from 'framer-motion'
import { useTranslation } from 'react-i18next'

function SriLankaSection() {
  const { t } = useTranslation();
  const containerRef = useRef(null);
  
  // Trigger animation when the section is 30% visible in the viewport
  const isInView = useInView(containerRef, { amount: 0.3, once: false });

  const [isTriggered, setIsTriggered] = useState(false);

  useEffect(() => {
      setIsTriggered(isInView);
  }, [isInView]);

  return (
    <div id="sri-lanka-section" ref={containerRef} className='relative w-full flex items-center justify-center bg-white overflow-hidden'>
        <motion.div 
            layout
            initial={false}
            animate={{
                width: isTriggered ? "85vw" : "100vw",
                height: isTriggered ? "85vh" : "100vh",
                borderRadius: isTriggered ? "40px" : "0px",
                marginTop: isTriggered ? "4rem" : "0rem",
                marginBottom: isTriggered ? "4rem" : "0rem"
            }}
            transition={{ layout: { duration: 0.9, type: "spring", bounce: 0.05 }, borderRadius: { duration: 0.9 } }} 
            className='relative overflow-hidden shadow-2xl flex items-center bg-gray-900 mx-auto'
            style={{ willChange: "width, height, border-radius, margin" }}
        >
            {/* Background Slider */}
            <div className='absolute inset-0 z-0'>
                <SriLankaImageSlider />
            </div>

            {/* Dynamic Gradient Overlay */}
            <motion.div 
                initial={false}
                animate={{ opacity: isTriggered ? 1 : 0.3 }}
                transition={{ duration: 1.0, ease: "easeOut" }}
                className='absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-gray-900/95 via-gray-900/80 md:via-gray-900/60 to-transparent z-10'
            ></motion.div>

            {/* Content */}
            <div className='relative z-20 w-full md:w-[75%] lg:w-[60%] p-8 md:p-16 flex flex-col gap-4 text-left'>
                <motion.span 
                    initial={false}
                    animate={{ opacity: isTriggered ? 1 : 0, y: isTriggered ? 0 : 20 }}
                    transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }}
                    className='text-KITH-primary font-bold tracking-widest uppercase text-[10px] md:text-xs'
                >
                    {t('destinations.subtitle')}
                </motion.span>
                
                <motion.h2 
                    initial={false}
                    animate={{ opacity: isTriggered ? 1 : 0, y: isTriggered ? 0 : 20 }}
                    transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
                    className='text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight'
                >
                    {t('destinations.title')}
                </motion.h2>
                
                <motion.p 
                    initial={false}
                    animate={{ opacity: isTriggered ? 1 : 0, y: isTriggered ? 0 : 20 }}
                    transition={{ duration: 0.6, delay: 0.3, ease: "easeOut" }}
                    className='text-white/80 text-xs md:text-base leading-relaxed font-light mt-2 max-w-2xl'
                >
                    {t('destinations.desc')}
                </motion.p>
                
                <motion.div 
                    initial={false}
                    animate={{ opacity: isTriggered ? 1 : 0, y: isTriggered ? 0 : 20 }}
                    transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
                    className='mt-4'
                >
                    <Link to="/about-sri-lanka" className='inline-flex items-center justify-center px-6 md:px-8 py-2.5 md:py-3 bg-KITH-primary text-white text-xs md:text-sm font-bold rounded-full hover:bg-white hover:text-gray-900 transition-colors shadow-md group'>
                        {t('destinations.discover_more')}
                        <i className="fi fi-br-arrow-right ml-2 text-[8px] md:text-[10px] group-hover:translate-x-1 transition-transform"></i>
                    </Link>
                </motion.div>
            </div>

        </motion.div>
    </div>
  )
}

export default SriLankaSection